export default "__VITE_ASSET__CFYVaHA4__"